import React from 'react';
import './index.css';
import imgPlaceholder from './../../../assets/images/placeholder/customer-image-placeholder.png';
import noDataFound from '../../../assets/images/icons/no-data-found.png';
import { useNavigate } from 'react-router-dom';
import { Image, Table } from 'react-bootstrap';

function DataTable({ columns, data }) {

  const navigate = useNavigate();

  return (
    <div className='datatable'>
      {
        data && data.length > 0 ?
          <Table>
            <thead className='table-head'>
              <tr>
                {
                  columns && columns.map((th_item, index) => {
                    return (
                      <th key={index} className={index === 0 ? 'ps-5 bg-table-head' : index === columns.length - 1 ? 'pe-5 bg-table-head' : 'p-3 bg-table-head'}>{th_item}</th>
                    )
                  })
                }
              </tr>
            </thead>
            <tbody>
              {
                data && data.map((tb_items, index) => {
                  return (
                    <tr key={index}>
                      <td className='ps-5 align-middle'>{index + 1}</td>
                      <td
                        className="align-middle cursor-pointer"
                        onClick={() => navigate('details', { state: { data: data, items: tb_items } })}
                      >
                        <div className='display_image'>
                          <Image src={tb_items.photo ? tb_items.photo : imgPlaceholder} alt='party-image' className='img-fluid' />
                        </div>
                      </td>
                      <td
                        className="align-middle cursor-pointer"
                        onClick={() => navigate('details', { state: { data: data, items: tb_items } })}
                      >
                        <div className='d-flex align-items-center text-primary'>
                          <span>{tb_items.name}</span>
                        </div>
                      </td>
                      <td className="align-middle">{tb_items.fatherHusband}</td>
                      <td className="align-middle">{tb_items.aadharNumber}</td>
                      <td className="align-middle">+91 {tb_items.phoneNumber}</td>
                      <td className="align-middle">{tb_items.city}, {tb_items.state}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
          :
          <div className='no-data-found'>
            <div className='d-block text-center'>
              <Image src={noDataFound} alt="no-data-found" className='img-fluid' />
              <div>No-Data Found</div>
            </div>
          </div>
      }
    </div>
  );
}

export default DataTable;
